import React from 'react';
import { useFormContext } from 'react-hook-form';

const Select = ({
    label,
    name,
    options = [],
    defaultOption,
    rules = {},
    className = '',
    labelClassName = '',
    errorClassName = '',
    valueKey = 'key',
    labelKey = 'name',
    ...rest
}) => {
    const { register } = useFormContext();

    const styles = {
        inputWrapper: {
            position: 'relative',
        },
    };

    return (
        <div style={styles.inputWrapper}>
            {label && (
                <label htmlFor={name} className={`select-label ${labelClassName}`}>
                    {label}
                </label>
            )}
            <select
                id={name}
                name={name}
                {...register(name, rules)}
                className={` ${className}`}
                {...rest}
            >
                {defaultOption && <option value="">{defaultOption}</option>}
                {options.map((option) => (
                    <option key={option[valueKey]} value={option[valueKey]}>
                        {option[labelKey]}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default Select;
